import React from 'react';

const TrustHubCnamAction = ({ isEditMode = false }) => {
  return (
    <button
      className="linear-gradient yr-submitbtn btn-sm"
      onClick={() => { window.location.href = '/trust-hub?tab=voice#cnam'; }}
    >
      <i className={isEditMode ? 'la la-edit' : 'la la-id-badge'}></i>{' '}
      {isEditMode ? 'Edit' : 'Add'} Caller ID Name (CNAM)
    </button>
  );
};

export default TrustHubCnamAction;
